/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesDraftPlayerSchema } from "./draftPlayerSchema.ts";
import { goodLuckCoreEntitiesRiotRegionSchema } from "./riotRegionSchema.ts";
import { goodLuckCoreEntitiesTournamentRegistrationSchema } from "./tournamentRegistrationSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesRiotAccountSchema = z.object({
  id: z.string().nullish(),
  userId: z.string().nullish(),
  gameName: z.string().min(1),
  tagLine: z.string().min(1),
  puuid: z.string().min(1),
  get region() {
    return goodLuckCoreEntitiesRiotRegionSchema;
  },
  profileIconId: z.optional(z.int()),
  isPrimary: z.optional(z.boolean()),
  isVerified: z.optional(z.boolean()),
  verificationIcon: z.int().nullish(),
  verifiedAt: z.iso.datetime().nullish(),
  currentRank: z.string().nullish(),
  currentRankLp: z.int().nullish(),
  source: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get tournamentRegistrations() {
    return z.array(goodLuckCoreEntitiesTournamentRegistrationSchema).nullish();
  },
  get draftPlayers() {
    return z.array(goodLuckCoreEntitiesDraftPlayerSchema).nullish();
  },
});
